import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {
  deleteCartItem,
  getCartItems,
  updateCart,
  updateCartLocal,
  getCartItemsLocal,
  deleteCartItemLocal
} from '../../../store/actions/user/User';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    boxShadow: 'none'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '76%'
  },
  content: {
    flex: '1 0 auto',
    padding: '2px'
  },
  cover: {
    width: '24%'
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  playIcon: {
    height: 10,
    width: 20
  }
}));

const MediaControlCard = (props) => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleQuantity = (product, change) => {
    // var getItems = JSON.parse(localStorage.getItem("cart"));
    // var setItems = getItems.filter((item, index) => {
    //   if (item.pid != product.pid) {
    //     return item;
    //   } else {
    //     updateItemIndex = index;
    //   }
    // });
    if (product.quantity > 1 && change === -1) {
      // var newQuantity = { ...product, quantity: product.quantity - 1 };
      // setItems.splice(updateItemIndex, 0, newQuantity);
      if (props.auth) {
        props
          .updateCart({
            cartId: props?.about?.id,
            quantity: props?.about?.quantity - 1
          })
          .then((data) => {
            if (data) {
              props.getCartItems();
            }
          });
      } else {
        const key = props?.about?.menuId ? 'menuId' : 'productId'
        var cartPayload = props.cart?.find((item) => item[key] === props?.about[key]);
        cartPayload.quantity = props?.about?.quantity - 1
        props.updateCartLocal(cartPayload, key);
        props.getCartItemsLocal();
      }
      // store.dispatch({ type: "GET_CART", payload: { data: setItems } });
    } else if (change === 1) {
      // var newQuantity = { ...product, quantity: product.quantity + 1 };
      // setItems.splice(updateItemIndex, 0, newQuantity);
      if (props.auth) {
        props
          .updateCart({
            cartId: props?.about?.id,
            quantity: props?.about?.quantity + 1
          })
          .then((data) => {
            if (data) {
              props.getCartItems();
            }
          });
      } else {
        const key = props?.about?.menuId ? 'menuId' : 'productId'
        var cartPayload = props.cart?.find((item) => item[key] === props?.about[key]);
        cartPayload.quantity = props?.about?.quantity + 1
        props.updateCartLocal(cartPayload, key);
        props.getCartItemsLocal();
      }
      // store.dispatch({ type: "GET_CART", payload: { data: setItems } });
    } else {
      if (props.auth) {
        props.deleteCartItem(product?.id).then((data) => {
          if (data) {
            props.getCartItems();
          }
        });
      } else {
        const key = props?.about?.menuId ? 'menuId' : 'productId'
        var cartPayload = props.cart?.find((item) => item[key] === props?.about[key]);
        props.deleteCartItemLocal(cartPayload, key);
        props.getCartItemsLocal();
      }
    }
    // localStorage.setItem("cart", JSON.stringify(setItems));
    // store.dispatch({ type: "GET_CART", payload: { data: setItems } });
  };

  const removeFromCart = (cart) => {
    // var getItems = JSON.parse(localStorage.getItem("cart"));
    // var setItems = getItems.filter((item) => item.pid != product.pid);
    // localStorage.setItem("cart", JSON.stringify(setItems));
    // store.dispatch({ type: "GET_CART", payload: { data: setItems } });
    if (props.auth) {
      props.deleteCartItem(cart?.id).then((data) => {
        if (data) {
          props.getCartItems();
        }
      });
    } else {
      const key = props?.about?.menuId ? 'menuId' : 'productId'
      var cartPayload = props.cart?.find((item) => item[key] === props?.about[key]);
      props.deleteCartItemLocal(cartPayload, key);
      props.getCartItemsLocal();
    }
  };

  const checkVariantPrice = (item) => {
    if (item.variant) {
      var variant_price = 0;
      item.variant.map((v) => {
        variant_price += parseFloat(v.price)
      })
      return variant_price
    } else {
      return 0
    }
  }

  return (
    <Card
      className={classes.root}
      style={{
        margin: '10px',
        paddingLeft: '2px',
        paddingBottom: '2px',
        paddingTop: '2px',
        height: '100px'
      }}
    >
      {!props.dontShowImage &&
        <CardMedia
          className={classes.cover}
          image={props.about.products[0]?.image}
          title="product"
        />
      }
      <div className={('row', classes.details)}>
        <CardContent
          className={classes.content}
          style={{ boxSizing: 'border-box', justifyContent: 'space-around' }}
        >
          <Typography
            component="p"
            variant="p"
            style={{ paddingLeft: '10px', fontWeight: 500, opacity: 1 }}
          >
            {props.about.products[0]?.name}
          </Typography>
          {props.about.variant &&
            <Typography
              component="p"
              variant="p"
              style={{
                paddingLeft: '10px', fontWeight: 500, opacity: 1, fontSize: '8px', background: 'rgb(1, 160, 90)',
                width: '24%',
                marginLeft: '3%',
                borderRadius: '4px',
                color: 'white',
                cursor: 'pointer'
              }}
              onClick={handleClickOpen}
            >Customized</Typography>
          }
          <div
            className={
              ('col-4 d-flex align-items-end flex-column', classes.controls)
            }
          >
            <Typography
              component="div"
              color="textSecondary"
              style={{
                color: 'inherit',
                fontWeight: 300,
                opacity: '0.6',
                paddingRight: '10px'
              }}
            >
              {((parseFloat(props.about.products[0]?.isOffer ? props.about.products[0]?.offerPrice : props.about.products[0]?.price) + checkVariantPrice(props.about)) *
                parseFloat(props.about.products[0].isMl || props.about.products[0].isGm ? props.about.quantity / 10 : props.about.quantity)).toFixed(2)}{' '}
              AUD
            </Typography>
            <IconButton
              aria-label="previous"
              onClick={() => handleQuantity(props.about, -1)}
            >
              <RemoveIcon
                style={{ textAlign: 'right', left: '10px', background: 'rgb(1, 160, 90)', color: 'white' }}
                className="btnAdd"
              />
            </IconButton>
            <Typography>{props.about.products[0].isGm || props.about.products[0].isMl ? props.about.quantity / 10 : props.about.quantity} {props.about.products[0].isGm ? 'KG' : (props.about.products[0].isMl ? 'L' : 'QTY')}</Typography>
            <IconButton
              aria-label="next"
              onClick={() => handleQuantity(props.about, 1)}
            >
              <AddIcon style={{ textAlign: 'right', background: 'rgb(1, 160, 90)', color: 'white' }} className="btnAdd" />
            </IconButton>
            <IconButton className="d-flex flex-row-reverse">
              <DeleteOutlineIcon
                style={{ color: 'rgb(1, 160, 90)', textAlign: 'right' }}
                onClick={() => removeFromCart(props.about)}
              ></DeleteOutlineIcon>
            </IconButton>
          </div>
        </CardContent>
        {/* <div className={("col-3", classes.controls)}>
          <Typography variant="subtitle1" color="textSecondary">
            $ {parseInt(props.about.price) * parseInt(props.about.quantity)}
          </Typography>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <IconButton
            style={{ marginLeft: "30px" }}
            aria-label="previous"
            onClick={() => handleQuantity(props.about, -1)}
          >
            <RemoveIcon className="btnAdd" />
          </IconButton>
          <Typography>{props.about.quantity}</Typography>
          <IconButton
            aria-label="next"
            onClick={() => handleQuantity(props.about, 1)}
          >
            <AddIcon />
          </IconButton>
          <IconButton>
            <DeleteOutlineIcon
              onClick={() => removeFromCart(props.about)}
            ></DeleteOutlineIcon>
          </IconButton>
        </div> */}
      </div>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <MuiDialogTitle>
          <Typography gutterBottom>
            <b>Add Ons</b>
          </Typography>
        </MuiDialogTitle>
        <MuiDialogContent>
          {props.about.variant && props.about.variant.map((v) => {
            return (
              <>
                <Typography gutterBottom>
                  <span><b>{v.name}</b></span>&nbsp;&nbsp;&nbsp;<span style={{ float: 'right' }}>{v.price + ' AUD'}</span>
                </Typography>
              </>)
          })}
        </MuiDialogContent>
        <MuiDialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Close
          </Button>
        </MuiDialogActions>
      </Dialog>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  cart: state.user.cart,
  auth: state.user.auth,
});

const mapDispatchToProps = (dispatch) => ({
  updateCart: (product) => dispatch(updateCart(product)),
  updateCartLocal: (product, key) => dispatch(updateCartLocal(product, key)),
  getCartItems: () => dispatch(getCartItems()),
  getCartItemsLocal: () => dispatch(getCartItemsLocal()),
  deleteCartItem: (cartId) => dispatch(deleteCartItem(cartId)),
  deleteCartItemLocal: (cartId, key) => dispatch(deleteCartItemLocal(cartId, key))
});

export default connect(mapStateToProps, mapDispatchToProps)(MediaControlCard);
